import ReactECharts from 'echarts-for-react';
import { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import '../../../../cssfiles/homepage.css';
import dayjs from 'dayjs';

const Linechartnew = (props) => {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const dateformatselected = useSelector((state) => state.mainpagedata.selecteddate);
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const livedata = useSelector((state) => state.mainpagedata.livedata);

    const [seriesChart, setSeriesChart] = useState([]);
    const [options, setOptions] = useState({});

    const theme = useSelector((state) => state.themedata.theme)
    var tag_properties = props.widgetprop.props.extended.tagprops;
    var color_properties_lines = [];
    var width_properties_lines = [];
    var curve_properties_lines = [];
    var tagname_properties_lines = [];
    const color_map = new Map();


    //this is extra
    tag_properties.map(charttype=>{
        color_properties_lines.push(charttype.chartprops.color);
        tagname_properties_lines.push(charttype.tagname);  
        color_map.set(charttype.tagname, charttype.chartprops.color);
    })

    //const[type,setType] = useState('line');

    var tag_properties = props.widgetprop.props.extended.tagprops;
    var color_properties = [];

  

    useEffect(() => {
        
        //setSeriesChart(seriesConsumed);
        //setOptions(optionsConsumption);
    }, [props.widgetprop/*, tagcollectionvalue*/]);

    useEffect(() => {
        if(livedata.length) {
            for(let i=0; i<livedata.length; i++) {
                //console.log("line chart ",livedata[i].TagId, props.widgetprop.props.extended.tagprops[0].tagid)
                /*if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                    setValue(livedata[i].value)
                    var date = new Date(livedata[i].timestamp * 1000)
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (date.getMonth()+1 > 9 ? date.getMonth()+1 : "0"+ date.getMonth()+1) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime(timestamp)
                }*/
            }
        }
    },[livedata])

    return (
        <>
        {/*console.log("seriesChart in linecharts",seriesChart)*/}
        <Chart options={options} series={seriesChart} type='line' height="85%" width="100%" />
        </>
    );
    };

export default Linechartnew;

